import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Game } from "../types";
import { GameDB } from "./Games";

export const getGameDetails = async (gameId: string): Promise<Game> => {
  const collectionRef = collection(db, "games");

  const gameSnapshot = await getDoc(doc(collectionRef, gameId));

  return new GameDB(gameSnapshot).toGame();
};
